import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function AdminEBI() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/bible-school/register").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-ebi-page">
      <p className="overline text-terracotta mb-2">Submissions</p>
      <h1 className="font-heading font-black text-4xl tracking-tighter text-olive mb-8">Bible School Registrations</h1>
      <div className="bg-white border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream border-b border-border">
            <tr className="text-left">
              <th className="p-4 font-semibold">Name</th>
              <th className="p-4 font-semibold">Email</th>
              <th className="p-4 font-semibold">Phone</th>
              <th className="p-4 font-semibold">Tenure</th>
              <th className="p-4 font-semibold">ID</th>
              <th className="p-4 font-semibold">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={6} className="p-8 text-center text-muted_ink">No registrations yet</td></tr>
            ) : items.map((m) => (
              <tr key={m.id} className="border-b border-border last:border-0">
                <td className="p-4 font-medium text-ink">{m.full_name}</td>
                <td className="p-4 text-muted_ink">{m.email}</td>
                <td className="p-4 text-muted_ink">{m.phone}</td>
                <td className="p-4"><span className="bg-terracotta text-white px-2.5 py-1 text-xs font-semibold">{m.tenure}</span></td>
                <td className="p-4 text-muted_ink">{m.id_number || "—"}</td>
                <td className="p-4 text-muted_ink">{new Date(m.created_at).toLocaleDateString("en-ZA")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
